var map = {
	"./basketball-active.webp": 1473,
	"./basketball.webp": 1474,
	"./bg.webp": 1475,
	"./football-active.webp": 1476,
	"./football.webp": 1477,
	"./games-active.webp": 1478,
	"./games.webp": 1479,
	"./information.webp": 1480,
	"./live-streaming-cover.webp": 1481,
	"./lv-active-bg.webp": 1482,
	"./video-bg.webp": 1483,
	"./video-icon.webp": 1484,
	"./vs.webp": 1485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 463;